<template>
    <div>
        <!-- Filtros -->
        <b-card class="shadow-sm mb-4">
            <b-card-title>Filtrar Boletos</b-card-title>
            <b-row>
                <b-col cols="12" md="4" class="mb-3">
                    <label class="font-weight-bold">Tipo</label>
                    <v-select
                        :options="listaTipos"
                        placeholder="Selecione o tipo"
                        v-model="filtro.tipo"
                        @input="onChangeTipos"
                    />
                </b-col>
                
                <b-col cols="12" md="8" class="mb-3" v-if="filtro.tipo && filtro.tipo.code === 'compra'">
                    <label class="font-weight-bold">Lote</label>
                    <v-select
                        :options="listaComboComprasDaFicha"
                        placeholder="Selecione o lote"
                        v-model="filtro.lote"
                    />
                </b-col>
                
                <b-col cols="12" md="8" class="mb-3" v-if="filtro.tipo && filtro.tipo.code === 'taxa'">
                    <label class="font-weight-bold">Taxa</label>
                    <v-select
                        :options="listaComboTaxasDaFicha"
                        placeholder="Selecione a taxa"
                        v-model="filtro.taxa"
                    />
                </b-col>
            </b-row>
        </b-card>

        <!-- Boletos por Compra (Sistema usa apenas boletos avulsos, não carnês) -->
        <div v-if="filtro.tipo && filtro.tipo.code === 'compra' && filtro.lote">
            <prestacoes 
                :modelId="filtro.lote.code" 
                :tipo="'compra'" 
                @atualizar="atualizar" 
                :key="'compra-' + chaveAtualizacao"
            />
        </div>
        
        <!-- Boletos por Taxa -->
        <div v-if="filtro.tipo && filtro.tipo.code === 'taxa' && filtro.taxa">
            <prestacoes 
                :modelId="filtro.taxa.code" 
                :tipo="'taxa'" 
                @atualizar="atualizar" 
                :key="'taxa-' + chaveAtualizacao"
            />
        </div>

        <!-- Parcelas de Entrada -->
        <div v-if="filtro.tipo && filtro.tipo.code === 'entrada'">
            <parcelas-entrada :fichaId="fichaId" :key="'entrada-' + chaveAtualizacao" />
        </div>
    </div>
</template>
<script>
import { mapActions } from 'vuex'

import api from '@/api/app.api.js'

import Prestacoes from './Financiamento/Prestacoes.vue'
import ParcelasEntrada from './Financiamento/ParcelasEntrada.vue'

export default {
    components: {
        Prestacoes,
        ParcelasEntrada
    },
    props: {
        fichaId: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            filtro: {
                tipo: { label: 'Lote', code: 'compra' },
                lote: null,
                taxa: null
            },
            listaTipos: [
                { label: 'Lote', code: 'compra' },
                { label: 'Taxa', code: 'taxa' },
                { label: 'Entrada', code: 'entrada' }
            ],
            listaComboComprasDaFicha: [],
            listaComboTaxasDaFicha: [],
            chaveAtualizacao: 0
        };
    },
    mounted() {
        this.obterListaComboComprasDaFicha()
    },
    methods: {
        ...mapActions('msgErro', { exibirMsgErro: 'exibirMsgErro' }),
        ...mapActions('msgSucesso', { exibirMsgSucesso: 'exibirMsgSucesso' }),
        onChangeTipos() {
            this.filtro.lote = null
            this.filtro.taxa = null

            if (this.filtro.tipo && this.filtro.tipo.code === 'compra') {
                this.obterListaComboComprasDaFicha()
            } else {
                this.obterListaComboTaxasDaFicha()
            }
        },
        obterListaComboComprasDaFicha() {
            api.obterListaComboComprasDaFicha(this.fichaId)
                .then(response => {
                    this.listaComboComprasDaFicha = response.data
                })
                .catch(() => {
                    this.exibirMsgErro()
                });
        },
        obterListaComboTaxasDaFicha() {
            api.obterListaComboTaxasDaFicha(this.fichaId)
                .then(response => {
                    this.listaComboTaxasDaFicha = response.data
                })
                .catch(() => {
                    this.exibirMsgErro()
                });
        },
        atualizar() {
            this.chaveAtualizacao++
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/Contrato/Components/Financiamento.vue